import { Checkbox, CheckboxProps, Text } from '@chakra-ui/react'

export default function ReviewDataCheckbox({
  disabled,
  alreadyInServer,
  checked,
  onChange,
  checkboxProps,
  textProps
}: {
  disabled?: boolean
  alreadyInServer?: boolean
  checked?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  checkboxProps?: CheckboxProps
  textProps?: CheckboxProps
}) {
  return (
    <Checkbox
      size={'lg'}
      isDisabled={disabled || alreadyInServer}
      isChecked={checked}
      onChange={onChange}
      {...checkboxProps}
    >
      <Text
        fontSize={'1rem'}
        fontWeight={'400'}
        color={'custom.gray.200'}
        {...textProps}
      >
        Salvar dado
      </Text>
    </Checkbox>
  )
}

export function ReviewDataCheckboxSingleValue<T>({
  currentValue,
  serverValue,
  formValue,
  set,
  reset,
  checkboxProps,
  textProps,
  disabled = false
}: {
  currentValue: T
  serverValue: T
  formValue: T
  set: (value: NonNullable<T>) => void
  reset: () => void
  checkboxProps?: CheckboxProps
  textProps?: CheckboxProps
  disabled?: boolean
}) {
  return (
    <ReviewDataCheckbox
      checkboxProps={checkboxProps}
      textProps={textProps}
      disabled={!currentValue || disabled}
      alreadyInServer={serverValue === currentValue}
      checked={formValue === currentValue}
      onChange={() => {
        if (formValue === currentValue) {
          reset()
        } else {
          if (!currentValue) return
          set(currentValue)
        }
      }}
    />
  )
}

export function ReviewDataCheckboxArrayValue<T>({
  currentValue,
  formValue,
  parallelValues,
  set,
  reset,
  comparison,
  checkboxProps,
  textProps,
  disabled = false
}: {
  currentValue: T
  parallelValues: T[]
  formValue: T[]
  set: (value: NonNullable<T>) => void
  reset: () => void
  comparison: (a: T, b: T) => boolean
  checkboxProps?: CheckboxProps
  textProps?: CheckboxProps
  disabled?: boolean
}) {
  return (
    <ReviewDataCheckbox
      checkboxProps={checkboxProps}
      textProps={textProps}
      disabled={!currentValue || disabled}
      alreadyInServer={parallelValues.some((item) =>
        comparison(item, currentValue)
      )}
      checked={formValue.some((item) => comparison(item, currentValue))}
      onChange={() => {
        if (formValue.some((item) => comparison(item, currentValue))) {
          reset()
        } else {
          if (!currentValue) return
          set(currentValue)
        }
      }}
    />
  )
}
